import { TheHeaderCartBadge } from '@cart-ui/TheHeaderCartBadge/fastpass/TheHeaderCartBadge'
import { Box } from '@pets-ui/Box/Box'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CartOutlined } from '@pets-ui/icons'
import { colors } from '@pets-ui/tokens/colors.stylex'

interface AppBarCartProps {
  isCartDisabled?: boolean
  onClick?: () => void
  cartItemQuantity?: number
}

export const AppBarCart = ({ isCartDisabled, onClick, cartItemQuantity }: AppBarCartProps) => {
  return (
    <Box position="relative">
      <IconButton onClick={onClick} disabled={isCartDisabled} width="32px" height="32px">
        <CartOutlined color={colors.grey900} fontSize={20} />
      </IconButton>
      <TheHeaderCartBadge totalQuantity={cartItemQuantity ?? 0} />
    </Box>
  )
}
